import { useState } from 'react';
import styles from './Form.module.css';
import EditFundingItem from '../EditFundingItem';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';

const FundingItem = ({ item, fundingFilters, updateFilters, enabledMap, toggleFilter }) => {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(null);

  return (
    <div>
      <div
        className={`${styles.row} ${styles.justifyBetween}`}
        style={{ margin: '10px 0px 5px 0px' }}
      >
        <div className={styles.label} style={{ fontWeight: 'bold' }}>
          {item.heading}
        </div>
        <button
          type="button"
          className={`detail-icon clickable ${styles.toggleButton}`}
          onClick={() => setOpen(!open)}
        >
          <KeyboardArrowDownOutlinedIcon fontSize="small" />
        </button>
      </div>

      {open &&
        item.fields.map((field) => (
          <div
            className={`${styles.row} ${styles.justifyBetween} ${styles.noMargin}`}
            key={field.key}
          >
            <div className={styles.row}>
              <input
                type="checkbox"
                name={field.key}
                onChange={(e) => {
                  if (fundingFilters[field.key]) {
                    toggleFilter(field.key, e.target.checked);
                  }
                }}
                checked={fundingFilters[field.key] ? enabledMap[field.key] : false}
                disabled={fundingFilters[field.key] ? false : true}
              />
              <label className={styles.label}>
                {field.label}: &nbsp;
                {field?.multiple === true && fundingFilters[field.key]?.includes(',')
                  ? 'All'
                  : fundingFilters[field.key] || 'N/A'}
              </label>
            </div>

            <div>
              <EditFundingItem
                dialogTitle="Edit Funding Filters"
                dialogContentText={
                  <div className={styles.dialogInputWrapper}>
                    <label className={styles.label}>{field.label} </label>

                    {field.type === 'select' ? (
                      <select
                        className="input-style w-full"
                        defaultValue={
                          field?.multiple === true && fundingFilters[field.key]?.includes(',')
                            ? 'All'
                            : fundingFilters[field.key] || ''
                        }
                        onChange={(e) => {
                          const val =
                            e.target.value === 'All' && field?.multiple === true
                              ? field.options.filter((option) => option !== 'All').join(', ')
                              : e.target.value;
                          setValue(val);
                        }}
                      >
                        <option value="" disabled>
                          Select a {field.label}
                        </option>
                        {field.options.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <input
                        type="text"
                        className="input-style w-full"
                        key={field.key}
                        defaultValue={fundingFilters[field.key] || ''}
                        onChange={(e) => setValue(e.target.value)}
                        placeholder={field.placeholder || ''}
                        maxLength={field.maxlength || undefined}
                      />
                    )}
                  </div>
                }
                index={field.key}
                id={field.key}
                action={(key) => updateFilters(key, value)}
              />
            </div>
          </div>
        ))}
    </div>
  );
};

export default FundingItem;
